module.exports = __webpack_public_path__ + "img/icon(3).0d6df70f.png";